module.exports = __webpack_public_path__ + "img/html.aa2b97f8.png";